module.exports = __webpack_public_path__ + "static/media/icon1.0b9beef9.jpg";